import React from 'react';

import PartsPicker from './PartsPicker.js';
import Notification from './Notification';
import { Loader } from './';
import { CdnContext } from '../context';

const PartsOverview = ({
    title,
    subtitle,
    description,
    topExplanation,
    bottomExplanation,
    parts,
    notification,
    closeNotification,
    loading,
}) =>
    (loading ? (
        <Loader />
    ) : (
        <div className="page page-parts-overview">
            <CdnContext.Consumer>
                {() => (
                    <div className="splitview">
                        <div className="split-left">
                            {/* <img
                                src={`${cdn}assets/images/tekstballon@2x.png`}
                                alt=""
                                className="decoration"
                            /> */}
                            <h1 className="welcome-heading">{title}</h1>
                            <h3 className="welcome-subtitle">{subtitle}</h3>
                            <div className="welcome-description">
                                <p
                                    // eslint-disable-next-line
                                    dangerouslySetInnerHTML={{
                                        __html: description,
                                    }}
                                />
                            </div>
                        </div>
                        <div className="split-right">
                            <div
                                className="parts-overview-description"
                                // eslint-disable-next-line
                                dangerouslySetInnerHTML={{
                                    __html: topExplanation,
                                }}
                            />
                            <PartsPicker parts={parts} />
                            <div
                                className="parts-overview-description"
                                // eslint-disable-next-line
                                dangerouslySetInnerHTML={{
                                    __html: bottomExplanation,
                                }}
                            />

                            <a href="#/poster" className="preview-poster-cta">
                                Bekijk jouw poster
                            </a>
                        </div>
                    </div>
                )}
            </CdnContext.Consumer>
            <Notification
                message={notification && notification}
                onClose={closeNotification}
            />
        </div>
    ));

export default PartsOverview;



// WEBPACK FOOTER //
// ./src/components/PartsOverview.js